import { FeatureWithPlans, PlanAvailability } from './feature-matrix.interface'

interface FeatureDependency {
  dependentKey: string
  requiredFeature: string
}

const FEATURE_DEPENDENCIES: Record<string, string> = {
  number_of_custom_ranches: 'custom_ranches_portfolio',
  number_of_reports_per_month: 'report_generation',
}

const isFeatureDisabled = (
  featureKey: string,
  planKey: string,
  features: FeatureWithPlans[]
): boolean => {
  const requiredFeature = FEATURE_DEPENDENCIES[featureKey]
  if (!requiredFeature) return false
  const dependency = features.find((v) => v.key === requiredFeature)
  return !Boolean(dependency?.plans[planKey as keyof PlanAvailability])
}

export default isFeatureDisabled
